import { MultiSelectInputFilter, ConditionProps } from 'framework/list';
import { OfficeDropdown } from 'domain/shared/employee';

const PositionSlotOfficeFilter = ({ label, ...props }: Omit<ConditionProps, 'children'> & { label: string }) => {
  return (
    <MultiSelectInputFilter {...props}>
      <OfficeDropdown source={props.source} label={label} multiple />
    </MultiSelectInputFilter>
  );
};

export default PositionSlotOfficeFilter;
